import type { DiscoverItem } from "../../types";
import type { CategoryStyle } from "./category-style";
import { thumbUrl } from "./thumb-url";

const THUMB_PX = 96;

function escapeAttr(s: string): string {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

function glyphSvg(style: CategoryStyle): string {
  return (
    `<svg viewBox="0 0 14 14" width="13" height="13" fill="none" stroke="currentColor" ` +
    `stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">` +
    `<path d="${style.glyph}"/></svg>`
  );
}

/** Photo pin: circular hero thumb + white inner border, category ring, badge, tip. */
export function photoPinHtml(
  item: Pick<DiscoverItem, "image" | "imageAlt" | "title">,
  style: CategoryStyle,
): string {
  const src = escapeAttr(thumbUrl(item.image, THUMB_PX));
  const alt = escapeAttr(item.imageAlt ?? item.title ?? "");
  return (
    `<span class="mj-pin__photo"><img src="${src}" alt="${alt}" loading="lazy" decoding="async"/></span>` +
    `<span class="mj-pin__badge">${glyphSvg(style)}</span>` +
    `<span class="mj-pin__tip"></span>`
  );
}

/** Fallback for image-less rows: a category disc with the glyph + tip. */
export function fallbackDiscHtml(style: CategoryStyle): string {
  return `<span class="mj-pin__disc">${glyphSvg(style)}</span><span class="mj-pin__tip"></span>`;
}

/** The bare category glyph — rendered inside the compact street-zoom marker. */
export function categoryGlyph(style: CategoryStyle): string {
  return glyphSvg(style);
}
